export default __webpack_public_path__ + "static/background-da4244aa1f75fab7607ac8a5fd229449.svg";